import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2AdminFormsCreate: build.mutation<
      PostV2AdminFormsCreateApiResponse,
      PostV2AdminFormsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/forms/create`,
        method: "POST",
        body: queryArg.adminCreateFormRequest,
      }),
    }),
    getV2ProviderForms: build.query<
      GetV2ProviderFormsApiResponse,
      GetV2ProviderFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms`,
        params: {
          scope: queryArg.scope,
          favorite: queryArg.favorite,
          tag: queryArg.tag,
          q: queryArg.q,
          form_type: queryArg.formType,
          include_drafts: queryArg.includeDrafts,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    postV2ProviderForms: build.mutation<
      PostV2ProviderFormsApiResponse,
      PostV2ProviderFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms`,
        method: "POST",
        body: queryArg.createFormRequest,
      }),
    }),
    postV2ProviderFormsFormBuilderGenerateFromText: build.mutation<
      PostV2ProviderFormsFormBuilderGenerateFromTextApiResponse,
      PostV2ProviderFormsFormBuilderGenerateFromTextApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/form-builder/generate-from-text`,
        method: "POST",
        body: queryArg.formBuilderTextGenerationRequest,
      }),
    }),
    postV2ProviderFormsFormBuilderUpload: build.mutation<
      PostV2ProviderFormsFormBuilderUploadApiResponse,
      PostV2ProviderFormsFormBuilderUploadApiArg
    >({
      query: () => ({
        url: `/v2/provider/forms/form-builder/upload`,
        method: "POST",
      }),
    }),
    getV2ProviderFormsFormBuilderWorkflowByWorkflowTaskId: build.query<
      GetV2ProviderFormsFormBuilderWorkflowByWorkflowTaskIdApiResponse,
      GetV2ProviderFormsFormBuilderWorkflowByWorkflowTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/form-builder/workflow/${queryArg.workflowTaskId}`,
      }),
    }),
    deleteV2ProviderFormsByFormId: build.mutation<
      DeleteV2ProviderFormsByFormIdApiResponse,
      DeleteV2ProviderFormsByFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderFormsByFormId: build.query<
      GetV2ProviderFormsByFormIdApiResponse,
      GetV2ProviderFormsByFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}`,
        params: {
          version: queryArg.version,
        },
      }),
    }),
    postV2ProviderFormsByFormIdClone: build.mutation<
      PostV2ProviderFormsByFormIdCloneApiResponse,
      PostV2ProviderFormsByFormIdCloneApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}/clone`,
        method: "POST",
        body: queryArg.cloneFormRequest,
      }),
    }),
    deleteV2ProviderFormsByFormIdDraft: build.mutation<
      DeleteV2ProviderFormsByFormIdDraftApiResponse,
      DeleteV2ProviderFormsByFormIdDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}/draft`,
        method: "DELETE",
      }),
    }),
    getV2ProviderFormsByFormIdDraft: build.query<
      GetV2ProviderFormsByFormIdDraftApiResponse,
      GetV2ProviderFormsByFormIdDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}/draft`,
      }),
    }),
    putV2ProviderFormsByFormIdDraft: build.mutation<
      PutV2ProviderFormsByFormIdDraftApiResponse,
      PutV2ProviderFormsByFormIdDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}/draft`,
        method: "PUT",
        body: queryArg.saveDraftRequest,
      }),
    }),
    postV2ProviderFormsByFormIdPublish: build.mutation<
      PostV2ProviderFormsByFormIdPublishApiResponse,
      PostV2ProviderFormsByFormIdPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/forms/${queryArg.formId}/publish`,
        method: "POST",
        body: queryArg.publishDraftRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2AdminFormsCreateApiResponse =
  /** status 200 OK */ FormResponse;
export type PostV2AdminFormsCreateApiArg = {
  adminCreateFormRequest: AdminCreateFormRequest;
};
export type GetV2ProviderFormsApiResponse =
  /** status 200 OK */ FormListResponse;
export type GetV2ProviderFormsApiArg = {
  /** Filter by owner scope */
  scope?: FormOwnerScope3 | null;
  /** Filter by favorite status */
  favorite?: boolean | null;
  /** Filter by tag */
  tag?: string | null;
  /** Search query */
  q?: string | null;
  /** Filter by form type */
  formType?: string | null;
  /** Include draft revisions in results */
  includeDrafts?: boolean | null;
  /** Sort field */
  sortBy?: string | null;
  /** Sort order (asc/desc) */
  sortOrder?: string | null;
  /** Page number */
  page?: number;
  /** Items per page */
  pageSize?: number;
};
export type PostV2ProviderFormsApiResponse = /** status 200 OK */ FormResponse;
export type PostV2ProviderFormsApiArg = {
  createFormRequest: CreateFormRequest;
};
export type PostV2ProviderFormsFormBuilderGenerateFromTextApiResponse =
  /** status 200 OK */ FormBuilderTextGenerationResponse;
export type PostV2ProviderFormsFormBuilderGenerateFromTextApiArg = {
  formBuilderTextGenerationRequest: FormBuilderTextGenerationRequest;
};
export type PostV2ProviderFormsFormBuilderUploadApiResponse =
  /** status 200 OK */ DocumentUploadResponse;
export type PostV2ProviderFormsFormBuilderUploadApiArg = void;
export type GetV2ProviderFormsFormBuilderWorkflowByWorkflowTaskIdApiResponse =
  /** status 200 OK */ FormBuilderDocumentUploadWorkflowResponse;
export type GetV2ProviderFormsFormBuilderWorkflowByWorkflowTaskIdApiArg = {
  workflowTaskId: string;
};
export type DeleteV2ProviderFormsByFormIdApiResponse =
  /** status 200 OK */ DeleteFormResponse;
export type DeleteV2ProviderFormsByFormIdApiArg = {
  formId: string;
};
export type GetV2ProviderFormsByFormIdApiResponse =
  /** status 200 OK */ FormResponse;
export type GetV2ProviderFormsByFormIdApiArg = {
  formId: string;
  /** Specific version number to retrieve */
  version?: number | null;
};
export type PostV2ProviderFormsByFormIdCloneApiResponse =
  /** status 200 OK */ FormResponse;
export type PostV2ProviderFormsByFormIdCloneApiArg = {
  formId: string;
  cloneFormRequest: CloneFormRequest;
};
export type DeleteV2ProviderFormsByFormIdDraftApiResponse =
  /** status 200 OK */ DiscardDraftResponse;
export type DeleteV2ProviderFormsByFormIdDraftApiArg = {
  formId: string;
};
export type GetV2ProviderFormsByFormIdDraftApiResponse =
  /** status 200 OK */ FormResponse;
export type GetV2ProviderFormsByFormIdDraftApiArg = {
  formId: string;
};
export type PutV2ProviderFormsByFormIdDraftApiResponse =
  /** status 200 OK */ SaveDraftResponse;
export type PutV2ProviderFormsByFormIdDraftApiArg = {
  formId: string;
  saveDraftRequest: SaveDraftRequest;
};
export type PostV2ProviderFormsByFormIdPublishApiResponse =
  /** status 200 OK */ PublishDraftResponse;
export type PostV2ProviderFormsByFormIdPublishApiArg = {
  formId: string;
  publishDraftRequest: PublishDraftRequest;
};
export type FormRevision = {
  /** Form schema/body */
  body: {
    [key: string]: any;
  };
  /** Creation timestamp */
  created_at?: string | null;
  /** Provider ID who created this revision */
  created_by: string;
  /** Form description */
  description?: string | null;
  /** Whether this is a draft */
  draft?: boolean;
  /** Parent form UUID */
  form_id: string;
  /** Publication timestamp */
  published_at?: string | null;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Version number */
  version: number;
};
export type FormOwnerScope = "public" | "org" | "provider";
export type Form = {
  /** Total number of completions */
  completions_total?: number;
  /** Creation timestamp */
  created_at?: string | null;
  created_by_principal_id?: string | null;
  created_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  /** Current published version */
  current_version?: number;
  /** Deletion timestamp for soft delete */
  deleted_at?: string | null;
  /** Type of form */
  form_type: string;
  /** Form UUID */
  id?: string | null;
  /** Last sent timestamp */
  last_sent_at?: string | null;
  /** Organization ID if org-scoped */
  organization_id?: string | null;
  /** Ownership scope */
  owner_scope: FormOwnerScope;
  /** Parent form ID for cloned forms */
  parent_form_id?: string | null;
  /** Unused for forms (no patient scope). Always None. */
  patient_id?: string | null;
  /** Provider ID who owns the form */
  provider_id: string;
  /** Resource-protocol scope, derived from owner_scope. Not persisted. */
  scope?: "global" | "organization" | "user" | "patient";
  /** Total number of times sent */
  sends_total?: number;
  /** Last update timestamp */
  updated_at?: string | null;
  /** User ID who owns the form (dual-write with provider_id) */
  user_id?: string | null;
};
export type ProviderFormCounter = {
  /** Number of completions by this provider */
  completions_total?: number;
  /** Form UUID */
  form_id: string;
  /** Last sent timestamp by this provider */
  last_sent?: string | null;
  /** Provider ID */
  provider_id: string;
  /** Number of times sent by this provider */
  sends_total?: number;
};
export type FormWithRevision = {
  /** The form's current revision (fields + layout). */
  current_revision?: FormRevision | null;
  /** The logical form metadata. */
  form: Form;
  /** Provider-specific usage stats */
  provider_usage?: ProviderFormCounter | null;
};
export type FormResponse = {
  form: FormWithRevision;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type GradingMatrixSchema = {
  /** Fields that are graded */
  graded_fields: string[];
  /** Score ranges and interpretations */
  ranges: {
    [key: string]: any;
  }[];
};
export type FormFieldOptionSchema = {
  /** Optional help text for the option */
  help_text?: string | null;
  /** Display label for the option */
  label: string;
  /** Value of the option */
  value: string | number;
};
export type FormFieldSchema = {
  /** Conditional display rules */
  conditional?: {
    [key: string]: any;
  } | null;
  /** Help text to display with the field */
  help_text?: string | null;
  /** Unique identifier for the field */
  id: string;
  /** Display label for the field */
  label: string;
  /** Number of points in likert scale (e.g., 5 for 1-5 scale) */
  likert_scale?: number | null;
  /** Maximum value for number fields */
  max_value?: number | number | null;
  /** Minimum value for number fields */
  min_value?: number | number | null;
  /** Options for select, radio, checkbox, or likert fields */
  options?: (string | FormFieldOptionSchema)[] | null;
  /** Placeholder text for input fields */
  placeholder?: string | null;
  /** Whether this field is required */
  required?: boolean;
  /** Number of rows for long_text fields */
  rows?: number | null;
  /** Field type (must be a valid FieldType) */
  type: string;
  /** Validation rules for the field */
  validation?: {
    [key: string]: any;
  } | null;
};
export type FormSectionSchema = {
  /** Whether section can be collapsed */
  collapsible?: boolean | null;
  /** Section description or instructions */
  description?: string | null;
  /** Fields in this section */
  fields: FormFieldSchema[];
  /** Optional section ID */
  id?: string | null;
  /** Whether section starts collapsed */
  initially_collapsed?: boolean | null;
  /** Section title (optional) */
  title?: string | null;
};
export type FormGroupSchema = {
  /** Group description or instructions */
  description?: string | null;
  /** Optional group ID */
  id?: string | null;
  /** Page number if form is paginated */
  page_number?: number | null;
  /** Sections in this group */
  sections: FormSectionSchema[];
  /** Group title (optional) */
  title?: string | null;
};
export type FormBodySchema = {
  /** Form description (if included in body) */
  description?: string | null;
  /** Type of form (e.g., 'standard', 'test') */
  form_type: string;
  /** Scoring matrix for test-type forms */
  grading_matrix?: GradingMatrixSchema | null;
  /** Groups of form sections */
  groups: FormGroupSchema[];
  /** ID of associated patient module for test forms */
  patient_module_id?: string | null;
  /** Form title (if included in body) */
  title?: string | null;
  [key: string]: any;
};
export type AdminCreateFormRequest = {
  /** Form body structure with groups, sections, and fields */
  body: FormBodySchema;
  /** Form description */
  description?: string | null;
  /** Type of form (standard/test) */
  form_type: string;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
};
export type FormRevisionSummary = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Provider ID who created this revision */
  created_by: string;
  /** Form description */
  description?: string | null;
  /** Whether this is a draft */
  draft?: boolean;
  /** Parent form UUID */
  form_id: string;
  /** Publication timestamp */
  published_at?: string | null;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Version number */
  version: number;
};
export type FormOwnerScope2 = "public" | "org" | "provider";
export type Form2 = {
  /** Total number of completions */
  completions_total?: number;
  /** Creation timestamp */
  created_at?: string | null;
  created_by_principal_id?: string | null;
  created_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  /** Current published version */
  current_version?: number;
  /** Deletion timestamp for soft delete */
  deleted_at?: string | null;
  /** Type of form */
  form_type: string;
  /** Form UUID */
  id?: string | null;
  /** Last sent timestamp */
  last_sent_at?: string | null;
  /** Organization ID if org-scoped */
  organization_id?: string | null;
  /** Ownership scope */
  owner_scope: FormOwnerScope2;
  /** Parent form ID for cloned forms */
  parent_form_id?: string | null;
  /** Unused for forms (no patient scope). Always None. */
  patient_id?: string | null;
  /** Provider ID who owns the form */
  provider_id: string;
  /** Resource-protocol scope, derived from owner_scope. Not persisted. */
  scope?: "global" | "organization" | "user" | "patient";
  /** Total number of times sent */
  sends_total?: number;
  /** Last update timestamp */
  updated_at?: string | null;
  /** User ID who owns the form (dual-write with provider_id) */
  user_id?: string | null;
};
export type ProviderFormCounter2 = {
  /** Number of completions by this provider */
  completions_total?: number;
  /** Form UUID */
  form_id: string;
  /** Last sent timestamp by this provider */
  last_sent?: string | null;
  /** Provider ID */
  provider_id: string;
  /** Number of times sent by this provider */
  sends_total?: number;
};
export type FormWithRevisionSummary = {
  /** Lightweight summary of the form's current revision. */
  current_revision?: FormRevisionSummary | null;
  /** The logical form metadata. */
  form: Form2;
  /** Provider-specific usage stats */
  provider_usage?: ProviderFormCounter2 | null;
};
export type FormListResponse = {
  items: FormWithRevisionSummary[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type FormOwnerScope3 = "public" | "org" | "provider";
export type GradingMatrixSchema2 = {
  /** Fields that are graded */
  graded_fields: string[];
  /** Score ranges and interpretations */
  ranges: {
    [key: string]: any;
  }[];
};
export type FormFieldOptionSchema2 = {
  /** Optional help text for the option */
  help_text?: string | null;
  /** Display label for the option */
  label: string;
  /** Value of the option */
  value: string | number;
};
export type FormFieldSchema2 = {
  /** Conditional display rules */
  conditional?: {
    [key: string]: any;
  } | null;
  /** Help text to display with the field */
  help_text?: string | null;
  /** Unique identifier for the field */
  id: string;
  /** Display label for the field */
  label: string;
  /** Number of points in likert scale (e.g., 5 for 1-5 scale) */
  likert_scale?: number | null;
  /** Maximum value for number fields */
  max_value?: number | number | null;
  /** Minimum value for number fields */
  min_value?: number | number | null;
  /** Options for select, radio, checkbox, or likert fields */
  options?: (string | FormFieldOptionSchema2)[] | null;
  /** Placeholder text for input fields */
  placeholder?: string | null;
  /** Whether this field is required */
  required?: boolean;
  /** Number of rows for long_text fields */
  rows?: number | null;
  /** Field type (must be a valid FieldType) */
  type: string;
  /** Validation rules for the field */
  validation?: {
    [key: string]: any;
  } | null;
};
export type FormSectionSchema2 = {
  /** Whether section can be collapsed */
  collapsible?: boolean | null;
  /** Section description or instructions */
  description?: string | null;
  /** Fields in this section */
  fields: FormFieldSchema2[];
  /** Optional section ID */
  id?: string | null;
  /** Whether section starts collapsed */
  initially_collapsed?: boolean | null;
  /** Section title (optional) */
  title?: string | null;
};
export type FormGroupSchema2 = {
  /** Group description or instructions */
  description?: string | null;
  /** Optional group ID */
  id?: string | null;
  /** Page number if form is paginated */
  page_number?: number | null;
  /** Sections in this group */
  sections: FormSectionSchema2[];
  /** Group title (optional) */
  title?: string | null;
};
export type FormBodySchema2 = {
  /** Form description (if included in body) */
  description?: string | null;
  /** Type of form (e.g., 'standard', 'test') */
  form_type: string;
  /** Scoring matrix for test-type forms */
  grading_matrix?: GradingMatrixSchema2 | null;
  /** Groups of form sections */
  groups: FormGroupSchema2[];
  /** ID of associated patient module for test forms */
  patient_module_id?: string | null;
  /** Form title (if included in body) */
  title?: string | null;
  [key: string]: any;
};
export type FormOwnerScope4 = "public" | "org" | "provider";
export type CreateFormRequest = {
  /** Form description */
  description?: string | null;
  /** Type of form */
  form_type: string;
  /** Initial form body/schema with validated structure */
  initial_body: FormBodySchema2;
  /** Organization ID if org-scoped */
  organization_id?: string | null;
  /** Ownership scope */
  owner_scope: FormOwnerScope4;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
};
export type FormBuilderTextGenerationResponse = {
  /** Success message */
  message: string;
  /** ID of the workflow task processing the form generation */
  workflow_task_id: string;
};
export type FormBuilderTextGenerationRequest = {
  /** UUID of existing form to update. If not provided, creates a new form. */
  form_id?: string | null;
  /** Text description of the form to generate */
  form_text_prompt: string;
};
export type DocumentUploadResponse = {
  /** Unique identifier for the uploaded document */
  document_id: string;
  /** Success message */
  message: string;
  /** ID of the workflow task processing the document */
  workflow_task_id: string;
};
export type FormBuilderDocumentUploadWorkflowResponse = {
  /** Timestamp when the workflow completed */
  date_done?: string | null;
  /** ID of the uploaded document */
  document_id?: string | null;
  /** Error message if workflow failed */
  error?: string | null;
  /** ID of the generated form definition if successful */
  form_id?: string | null;
  /** Whether the workflow has completed (success or failure) */
  is_complete: boolean;
  /** Whether the workflow completed successfully */
  is_success: boolean;
  /** Result data if workflow completed successfully */
  result?: {
    [key: string]: any;
  } | null;
  /** Current status of the workflow (PENDING, STARTED, SUCCESS, FAILURE, RETRY, REVOKED) */
  status: string;
  /** ID of the workflow task */
  workflow_task_id: string;
};
export type DeleteFormResponse = {
  /** Success or error message */
  message: string;
  /** Whether the form was successfully deleted */
  success: boolean;
};
export type FormOwnerScope5 = "public" | "org" | "provider";
export type CloneFormRequest = {
  /** Scope for the cloned form */
  new_scope: FormOwnerScope5;
  /** Organization ID if cloning to org scope */
  organization_id?: string | null;
};
export type DiscardDraftResponse = {
  /** Success or error message */
  message: string;
  /** Whether the draft was successfully discarded */
  success: boolean;
};
export type FormRevision2 = {
  /** Form schema/body */
  body: {
    [key: string]: any;
  };
  /** Creation timestamp */
  created_at?: string | null;
  /** Provider ID who created this revision */
  created_by: string;
  /** Form description */
  description?: string | null;
  /** Whether this is a draft */
  draft?: boolean;
  /** Parent form UUID */
  form_id: string;
  /** Publication timestamp */
  published_at?: string | null;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Version number */
  version: number;
};
export type SaveDraftResponse = {
  message?: string;
  revision: FormRevision2;
};
export type GradingMatrixSchema3 = {
  /** Fields that are graded */
  graded_fields: string[];
  /** Score ranges and interpretations */
  ranges: {
    [key: string]: any;
  }[];
};
export type FormFieldOptionSchema3 = {
  /** Optional help text for the option */
  help_text?: string | null;
  /** Display label for the option */
  label: string;
  /** Value of the option */
  value: string | number;
};
export type FormFieldSchema3 = {
  /** Conditional display rules */
  conditional?: {
    [key: string]: any;
  } | null;
  /** Help text to display with the field */
  help_text?: string | null;
  /** Unique identifier for the field */
  id: string;
  /** Display label for the field */
  label: string;
  /** Number of points in likert scale (e.g., 5 for 1-5 scale) */
  likert_scale?: number | null;
  /** Maximum value for number fields */
  max_value?: number | number | null;
  /** Minimum value for number fields */
  min_value?: number | number | null;
  /** Options for select, radio, checkbox, or likert fields */
  options?: (string | FormFieldOptionSchema3)[] | null;
  /** Placeholder text for input fields */
  placeholder?: string | null;
  /** Whether this field is required */
  required?: boolean;
  /** Number of rows for long_text fields */
  rows?: number | null;
  /** Field type (must be a valid FieldType) */
  type: string;
  /** Validation rules for the field */
  validation?: {
    [key: string]: any;
  } | null;
};
export type FormSectionSchema3 = {
  /** Whether section can be collapsed */
  collapsible?: boolean | null;
  /** Section description or instructions */
  description?: string | null;
  /** Fields in this section */
  fields: FormFieldSchema3[];
  /** Optional section ID */
  id?: string | null;
  /** Whether section starts collapsed */
  initially_collapsed?: boolean | null;
  /** Section title (optional) */
  title?: string | null;
};
export type FormGroupSchema3 = {
  /** Group description or instructions */
  description?: string | null;
  /** Optional group ID */
  id?: string | null;
  /** Page number if form is paginated */
  page_number?: number | null;
  /** Sections in this group */
  sections: FormSectionSchema3[];
  /** Group title (optional) */
  title?: string | null;
};
export type FormBodySchema3 = {
  /** Form description (if included in body) */
  description?: string | null;
  /** Type of form (e.g., 'standard', 'test') */
  form_type: string;
  /** Scoring matrix for test-type forms */
  grading_matrix?: GradingMatrixSchema3 | null;
  /** Groups of form sections */
  groups: FormGroupSchema3[];
  /** ID of associated patient module for test forms */
  patient_module_id?: string | null;
  /** Form title (if included in body) */
  title?: string | null;
  [key: string]: any;
};
export type SaveDraftRequest = {
  /** Form body/schema to save as draft with validated structure */
  body: FormBodySchema3;
  /** Form description */
  description?: string | null;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
};
export type FormRevision3 = {
  /** Form schema/body */
  body: {
    [key: string]: any;
  };
  /** Creation timestamp */
  created_at?: string | null;
  /** Provider ID who created this revision */
  created_by: string;
  /** Form description */
  description?: string | null;
  /** Whether this is a draft */
  draft?: boolean;
  /** Parent form UUID */
  form_id: string;
  /** Publication timestamp */
  published_at?: string | null;
  /** Form tags */
  tags?: string[];
  /** Form title */
  title: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Version number */
  version: number;
};
export type PublishDraftResponse = {
  message?: string;
  revision: FormRevision3;
};
export type PublishDraftRequest = {};
